import { Guid, RecursivePartial } from '@models/base';
import { CodeSnippet } from '@models/shared/code-snippet';
import { WikiDocBase } from './doc-base';

export const MAX_WIKI_LENGTH = 1024 * 1024;

export class WikiDoc extends WikiDocBase {
    richText?: { [key: string]: any };
    snippets?: CodeSnippet[];
    children?: WikiDoc[];

    constructor(json?: RecursivePartial<WikiDoc>) {
        super(json);
        this.parseWikiDoc(json || {});
    }

    parse(json: RecursivePartial<WikiDoc>): WikiDoc {
        super.parse(json);
        this.parseWikiDoc(json);
        return this;
    }

    private parseWikiDoc(json: RecursivePartial<WikiDoc>): void {
        WikiDoc.assignFields(this, json, ['richText']);
        WikiDoc.assignClassArrays<WikiDoc>(this, json, { children: WikiDoc, snippets: CodeSnippet, hierarchy: WikiDocBase });
    }
}
